export const ReturnCompleteSelect = (SelectableDataArray, UiValue) => {
  let CompleteSelect;
  CompleteSelect = SelectableDataArray.filter((item) =>
    UiValue.includes(item.ItemValue)
  );
  return CompleteSelect;
};
